export { ShowCarousal as default } from "./show-carousal";
export type { ShowCarousalProps } from "./show-carousal";
